"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var ReactDOM = _interopRequireWildcard(require("react-dom"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _rooMotion = require("@thh/roo-motion");
var _ConfigProvider = require("../ConfigProvider");
var _Dom = require("../_utils/Dom");
var _ToastEntity = _interopRequireDefault(require("./ToastEntity"));
var _interface = require("./interface");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = _Reflect$construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import './test.css'
var CSSMotionList = _rooMotion.CSSAnimate.CSSMotionList;
/**
 * 缓存当前每个Toast 的key， 用于限制最大个数
 */
var currentToastKey = [];
var random = function random() {
  return Math.random().toString(36).substring(2, 8);
};
/**
 * 根据 placement 生成 Toast 容器的样式
 * @param placement string
 * @param position object
 * @return 容器样式
 */
var generateStyle = function generateStyle(placement, position) {
  var zIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1200;
  // 分割小驼峰获取位置信息
  var _placement$replace$to = placement.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase().split('-'),
    _placement$replace$to2 = (0, _slicedToArray2.default)(_placement$replace$to, 2),
    first = _placement$replace$to2[0],
    second = _placement$replace$to2[1];
  var style = {};
  if (first === 'center') {
    style = {
      top: '50%',
      left: '50%',
      transform: 'translate3d(-50%, -50%, 0)'
    };
  } else {
    var _ref, _ref2;
    style = second === 'center' ? (_ref = {}, (0, _defineProperty2.default)(_ref, first, position[first] || '60px'), (0, _defineProperty2.default)(_ref, "left", '50%'), (0, _defineProperty2.default)(_ref, "transform", 'translate3d(-50%, 0, 0)'), _ref) : (_ref2 = {}, (0, _defineProperty2.default)(_ref2, first, position[first] || '60px'), (0, _defineProperty2.default)(_ref2, second, position[second] || '60px'), _ref2);
  }
  return (0, _assign.default)({
    position: 'fixed',
    zIndex: zIndex
  }, style);
};
/**
 * Roo-theme 内样式无效
 * 覆盖 Toast 默认样式
 */
var toastStyle = {
  display: 'block',
  position: 'relative',
  transform: 'none',
  left: 'auto',
  top: 'auto',
  marginBottom: '20px'
};
/**
 * Toast 容器组件
 */
var ToastWrap = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ToastWrap, _React$Component);
  var _super = _createSuper(ToastWrap);
  function ToastWrap() {
    var _this;
    (0, _classCallCheck2.default)(this, ToastWrap);
    _this = _super.apply(this, arguments);
    _this.state = {
      configs: [_this.props.initConfig]
    };
    _this.add = function (config) {
      var key = config.key;
      var configs = _this.state.configs;
      var index = configs.findIndex(function (fonfig) {
        return fonfig.key === key;
      });
      // 如果在configs 记录中找到对应的key的话，是更改现有弹窗的信息，直接更新即可
      if (index > -1) {
        configs.splice(index, 1, (0, _assign.default)((0, _assign.default)({}, config), {
          updateTimer: random()
        }));
        _this.setState({
          configs: (0, _toConsumableArray2.default)(configs)
        });
      } else {
        _this.setState(function (state) {
          return {
            configs: [].concat((0, _toConsumableArray2.default)(state.configs), [config])
          };
        });
      }
    };
    _this.remove = function (key) {
      var curConfig = _this.state.configs.filter(function (config) {
        return config.key === key;
      })[0] || {};
      currentToastKey = currentToastKey.filter(function (fkey) {
        return fkey !== key;
      });
      _this.setState(function (state) {
        return {
          configs: state.configs.filter(function (config) {
            return config.key !== key;
          })
        };
      }, function () {
        /* eslint-disable-next-line */
        curConfig.onClose && curConfig.onClose();
      });
    };
    _this.getCollapsedHeight = function () {
      return {
        height: 0,
        opacity: 0
      };
    };
    _this.getRealHeight = function (node) {
      return {
        height: node.clientHeight,
        opacity: 1
      };
    };
    return _this;
  }
  (0, _createClass2.default)(ToastWrap, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var configs = this.state.configs;
      var position = this.props.position;
      var _this$props$initConfi = this.props.initConfig,
        top = _this$props$initConfi.top,
        bottom = _this$props$initConfi.bottom,
        left = _this$props$initConfi.left,
        right = _this$props$initConfi.right,
        zIndex = _this$props$initConfi.zIndex,
        closeMotion = _this$props$initConfi.closeMotion;
      var wrapStyle = generateStyle(position, {
        top: top,
        left: left,
        right: right,
        bottom: bottom
      }, zIndex);
      var currentConfigs = (configs || []).map(function (item) {
        return {
          key: item.key,
          toastMotionInfo: (0, _assign.default)({}, item)
        };
      });
      return /*#__PURE__*/React.createElement("div", {
        style: wrapStyle
      }, /*#__PURE__*/React.createElement(CSSMotionList, {
        keys: currentConfigs,
        motionName: closeMotion ? '' : "".concat(this.context.prefixCls, "-toast-motion"),
        onLeaveStart: this.getRealHeight,
        onLeaveActive: this.getCollapsedHeight
      }, function (motionParams) {
        var key = motionParams === null || motionParams === void 0 ? void 0 : motionParams.key;
        var motionClassName = (motionParams === null || motionParams === void 0 ? void 0 : motionParams.className) || '';
        var motionStyle = (motionParams === null || motionParams === void 0 ? void 0 : motionParams.style) || {};
        var config = (0, _assign.default)({}, motionParams.toastMotionInfo);
        var style = config.style;
        var rest = (0, _omit.default)(config, ['top', 'left', 'right', 'bottom', 'style', 'key', 'popupContainer', 'maxCount']);
        var styles = (0, _assign.default)((0, _assign.default)({}, toastStyle), style);
        var currentPosition = rest.position || 'topRight';
        var currentMotionClassName = motionClassName.split(' ').filter(function (name) {
          return name;
        }).map(function (name) {
          return "".concat(name, "-").concat(currentPosition);
        }).join(' ');
        return /*#__PURE__*/React.createElement("div", {
          style: (0, _assign.default)({}, motionStyle),
          className: currentMotionClassName
        }, /*#__PURE__*/React.createElement(_ToastEntity.default, (0, _assign.default)({}, rest, {
          key: key,
          onClose: function onClose() {
            _this2.remove(key);
          },
          style: styles
        })));
      }));
    }
  }]);
  return ToastWrap;
}(React.Component);
ToastWrap.contextType = _ConfigProvider.GlobalConfigContext;
ToastWrap.propTypes = {
  initConfig: PropTypes.object.isRequired,
  position: PropTypes.oneOf(_interface.positions)
};
ToastWrap.defaultProps = {
  position: 'topRight'
};
// const IS_REACT_16 = !!ReactDOM.createPortal;
var toastWrapRef = {};
var defaultPosition = _interface.positions;
/**
 * 缓存不同 position 的容器 DOM
 */
var positionWrapDOM = {};
/**
 * 缓存每个 position 上的 toast 实例
 */
var keyToPosition = {};
//@ts-ignore
var ToastFun = {
  open: open,
  close: _close,
  destroy: destroy
};
_interface.statusTypes.forEach(function (item) {
  ToastFun[item] = function () {
    var initProps;
    for (var _len = arguments.length, restProps = new Array(_len), _key = 0; _key < _len; _key++) {
      restProps[_key] = arguments[_key];
    }
    if (restProps[0] && (restProps[0].children || restProps[0].title)) {
      initProps = (0, _assign.default)({
        status: item
      }, restProps[0]);
    } else {
      var children = restProps[0],
        duration = restProps[1],
        onClose = restProps[2];
      initProps = {
        status: item,
        children: children,
        duration: duration,
        onClose: onClose
      };
    }
    open(initProps);
  };
});
/**
 * 创建一个 Toast
 * @param props
 */
function open(props) {
  var _props$position = props.position,
    position = _props$position === void 0 ? 'topRight' : _props$position,
    popupContainer = props.popupContainer,
    maxCount = props.maxCount;
  var global = (0, _ConfigProvider.globalConfig)();
  var innerPosition = defaultPosition.indexOf(position) > -1 ? position : 'topRight';
  props.key = props.key ? props.key : random();
  keyToPosition[props.key] = innerPosition;
  // 超过最大个数关闭最前面的
  if (maxCount && currentToastKey.length >= maxCount) {
    var closeKey = currentToastKey.shift();
    if (closeKey) {
      // @ts-ignore
      _close(closeKey);
    }
  }
  currentToastKey.push(props.key);
  if ((!positionWrapDOM[innerPosition] || popupContainer) && !(0, _Dom.contains)((0, _Dom.getContainer)(popupContainer), positionWrapDOM[innerPosition])) {
    positionWrapDOM[innerPosition] = document.createElement('div');
    positionWrapDOM[innerPosition].setAttribute('data-position', innerPosition);
    (0, _Dom.getContainer)(popupContainer).appendChild(positionWrapDOM[innerPosition]);
    render(positionWrapDOM[innerPosition]);
  } else {
    // 解决异步未取到元素实例时报错问题
    setTimeout(function () {
      if (!toastWrapRef[innerPosition]) return;
      toastWrapRef[innerPosition].add(props);
    });
  }
  function toastRef(toast) {
    toastWrapRef[innerPosition] = toast;
  }
  function render(DOM) {
    var dom = /*#__PURE__*/React.createElement(ToastWrap, {
      ref: toastRef,
      position: innerPosition,
      initConfig: props
    });
    ReactDOM.render((global === null || global === void 0 ? void 0 : global.holderRender) ? global.holderRender(dom) : dom, DOM);
  }
  return {
    close: function close() {
      return _close(props.key);
    }
  };
}
/**
 * 关闭一个 Toast
 * @param key 用户自定义的 key，或者随机生成的。
 */
function _close(key) {
  var position = keyToPosition[key];
  if (position) {
    toastWrapRef[position].remove(key);
  }
}
/**
 * 销毁所有位置的 Toast
 */
function destroy() {
  currentToastKey = [];
  (0, _keys.default)(positionWrapDOM).map(function (key) {
    if (positionWrapDOM[key]) {
      ReactDOM.unmountComponentAtNode(positionWrapDOM[key]);
      positionWrapDOM[key].parentNode.removeChild(positionWrapDOM[key]);
      // @ts-ignore
      positionWrapDOM[key] = null;
      return true;
    }
    return false;
  });
}
var _default = exports.default = ToastFun;